import './Head.css';

import pool from "./1.jpg";

import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import { HashLink } from 'react-router-hash-link';


export default function Head() {

    useEffect(() => {
        Aos.init();
    }, []);

    return <header id='home'>
            
                <div className='chl-head'>
                    <h1 data-aos="fade-up" data-aos-duration="1000">Pristine Pool Care for Your Oasis</h1>
                    <p data-aos="fade-up" data-aos-duration="1200">Experience the ultimate in pool maintenance with our expert services. Our team ensures your pool remains crystal clear and inviting all year round. From regular cleaning to comprehensive checks, we tailor our services to meet your needs.</p>
                    <HashLink to='/#serviec' data-aos="fade-up" data-aos-duration="1400" >Learn more</HashLink>
                </div>

            <img src={pool} alt='hd-img' id='hd-img' data-aos="zoom-out" data-aos-duration="3000"/>
            
        </header>
}
